import { PageTitle } from '@/components/seo/page-title';
import { DiscoverScreen } from '@/features/discover/discover-screen';
import React from 'react';

export default function DiscoverRoute() {
  return (
    <>
      <PageTitle title="Discover" />
      <DiscoverScreen />
    </>
  );
}
